/* naire-paso-cero.js
   JS de sections/naire-paso-cero.liquid. Va como asset y no inline porque
   una seccion re-renderizada por el Section Rendering API vuelve a parsear
   todo su <script>; como asset se cachea y se parsea una sola vez.
   Sin Liquid adentro a proposito: lo que viene del editor entra por data-*
   (ver data-npz-cart), no interpolado aca.

   Todo se resuelve dentro de la instancia (this), nunca con
   document.querySelector('.npz'): la seccion puede estar dos veces en la
   misma pagina y cada una tiene su nav, sus paneles y su scrollspy. */
(function () {
  'use strict';

  if (customElements.get('naire-paso-cero')) return;

  /* Selectores de respaldo para el boton, en orden. El tema de Naire no usa
     el <form action="/cart/add"> estandar de Shopify -la compra pasa por un
     boton propio-, asi que el default del schema no encuentra nada. En vez de
     depender de que alguien configure el selector correcto, se prueba una
     cadena: primero lo que diga el editor, despues la seccion principal del
     producto (Shopify siempre la nombra __main), despues el picker de variante. */
  var RESPALDOS = ['section[id*="__main"]', '[id*="__main"]', '.product-form__input'];

  customElements.define('naire-paso-cero', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var self = this;

      this._tabs = [].slice.call(this.querySelectorAll('.npz__tab'));
      this._panels = this._tabs
        .map(function (t) { return self.querySelector('#' + CSS.escape(t.getAttribute('data-npz-target'))); })
        .filter(Boolean);

      this._onTab = function (ev) {
        var tab = ev.currentTarget;
        var el = self.querySelector('#' + CSS.escape(tab.getAttribute('data-npz-target')));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        self.activar(tab.getAttribute('data-npz-target'));
      };
      this._tabs.forEach(function (tab) { tab.addEventListener('click', self._onTab); });

      /* El offset del header se mide solo. Antes era un numero que habia que
         cargar a mano en el editor y que quedaba mal apenas el tema cambiaba
         la altura del header: con 0, la nav pegajosa quedaba tapada y sus
         pestañas no se podian clickear. Si el editor trae un valor > 0 se
         respeta como override manual. */
      this._medirOffset = function () {
        var manual = parseInt(getComputedStyle(self).getPropertyValue('--npz-offset'), 10) || 0;
        if (self._manual === undefined) self._manual = manual;
        if (self._manual > 0) return;

        var alto = 0;
        var pila = document.elementsFromPoint(Math.round(window.innerWidth / 2), 1) || [];
        for (var i = 0; i < pila.length; i++) {
          var el = pila[i];
          if (self.contains(el)) continue;          /* la propia nav no cuenta */
          var pos = getComputedStyle(el).position;
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          var r = el.getBoundingClientRect();
          if (r.height > 0 && r.top <= 1) alto = Math.max(alto, Math.round(r.bottom));
        }
        if (alto > 200) alto = 0;                    /* algo raro: mejor 0 que romper */
        /* Solo se escribe si cambio: esto corre en cada frame de scroll y
           tocar el style igual dispara un recalculo de estilo al pedo. */
        if (alto !== self._offsetActual) {
          self._offsetActual = alto;
          self.style.setProperty('--npz-offset', alto + 'px');
        }
      };

      /* Scrollspy: marca el panel cuyo inicio quedo mas arriba de la linea
         de lectura. rAF para no leer layout en cada evento de scroll. */
      var ticking = false;
      this._spy = function () {
        ticking = false;
        /* El header de este tema no esta siempre fijo: se esconde al bajar y
           reaparece al subir. Por eso el offset se remide en cada frame de
           scroll y no una sola vez: con un valor fijo quedaria un hueco muerto
           -con el contenido pasando por detras- cada vez que el header no esta. */
        self._medirOffset();
        var offset = parseInt(getComputedStyle(self).getPropertyValue('--npz-offset'), 10) || 0;
        var linea = offset + window.innerHeight * 0.35;
        var actual = self._panels[0];
        for (var i = 0; i < self._panels.length; i++) {
          if (self._panels[i].getBoundingClientRect().top <= linea) actual = self._panels[i];
        }
        if (actual) self.activar(actual.id);
      };
      this._onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(self._spy); }
      };
      this._onResize = function () { self._medirOffset(); self._spy(); };

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);

      this._medirOffset();
      this._spy();
      /* El header de varios temas se monta tarde (o cambia de alto al fijarse):
         una segunda medicion al cargar todo evita quedarse con el valor viejo. */
      this._reintento = setTimeout(function () { self._medirOffset(); self._spy(); }, 800);

      /* El boton no navega: sube al bloque de compra de la pagina de producto.
         Si no encuentra nada no hace nada -antes iba al body, que desde el
         panel de abajo se leia como un salto al azar. */
      this._cta = this.querySelector('[data-npz-scroll-to-form]');
      if (this._cta) {
        this._onCta = function () {
          var candidatos = [self.getAttribute('data-npz-cart')].concat(RESPALDOS);
          for (var i = 0; i < candidatos.length; i++) {
            if (!candidatos[i]) continue;
            var destino = null;
            try { destino = document.querySelector(candidatos[i]); } catch (e) { destino = null; }
            if (destino && !self.contains(destino)) {
              destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
              return;
            }
          }
        };
        this._cta.addEventListener('click', this._onCta);
      }
    }

    activar(id) {
      this._tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-npz-target') === id);
      });
    }

    disconnectedCallback() {
      /* Section Rendering API: el editor re-monta la seccion en cada cambio */
      var self = this;
      if (this._reintento) { clearTimeout(this._reintento); this._reintento = null; }
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._tabs && this._onTab) {
        this._tabs.forEach(function (t) { t.removeEventListener('click', self._onTab); });
      }
      if (this._cta && this._onCta) this._cta.removeEventListener('click', this._onCta);
      this._manual = undefined;
      this._offsetActual = undefined;
      this._init = false;
    }
  });
})();
